import { isObject, isArray } from './validator.js';

export function hasOwnProperty(object, key) {
  return Object.prototype.hasOwnProperty.call(object, key);
}

export function serialize(params) {
  if (!params) {
    return '';
  }

  const result = Object.keys(params).reduce((acc, key, index) => {
    if (index > 0) {
      acc += '&';
    }

    let value = params[key];
    if (isObject(value) || isArray(value)) {
      value = JSON.stringify(value);
    }

    acc += `${key}=${value}`;

    return acc;
  }, '?');

  return result;
}

export function updateObject(original, newest) {
  for (let key in newest) {
    if (!hasOwnProperty(original, key)) continue;

    const ov = original[key];
    const nv = newest[key];
    if (isObject(ov) && isObject(nv)) {
      original[key] = updateObject(ov, nv);
    } else {
      original[key] = nv;
    }
  }

  return original;
}
